<p-toast key="si-messages" position="top-right"></p-toast>
<div [class.divider-bottom]="containerDetailsForm?.controls.length > 1" class="p-py-3"
     *ngFor="let containerForm of containerDetailsForm?.controls; let i = index ">


    <div class="p-text-right p-pb-2">
        [{{i + 1}} / {{containerDetailsForm?.controls?.length}}]
    </div>
    <div [formGroup]="containerForm">

        <!--            Start: Basic Container Details & Docs-->
        <div>
            <div class="p-grid p-ai-center width-100">
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label>Cargo Type *</label>
                        <p-dropdown [options]="containerTypesArray" appendTo="body"
                                    emptyMessage="No Types found"
                                    formControlName="cargoType"
                                    [disabled]="this.isPreviewSI"
                                    optionLabel="containerDescription"
                                    optionValue="containerId"
                                    placeholder="Select..."
                                    styleClass="si-dropdown "></p-dropdown>
                        <!--                    (onChange)="resetContainerDetailsForm($event)"-->
                    </div>

                </div>
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label>Container SubType</label>
                        <input class="width-100" disabled
                               formControlName="containerSubTypeDescription" pInputText
                               type="text">
                    </div>
                </div>
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label>Container Number</label>
                        <input class="width-100"
                               formControlName="containerNumber"
                               pInputText
                        >
                    </div>


                </div>
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-d-flex p-jc-between p-ai-center width-100">
                        <div>
                            <h5 class="p-m-0"
                                style="opacity: .7;">Upload VGM Document(PDF Only)</h5>
                            <small class="p-text-warning">Max Filesize: 20MB</small>
                        </div>
                        <div>
                            <p-fileUpload #fileUploadVGM [customUpload]="true"
                                          [invalidFileSizeMessageDetail]="'File size is greater than 20MB'"
                                          [invalidFileSizeMessageSummary]="'Invalid File Size'"
                                          [maxFileSize]="2e+7"
                                          [disabled]="isPreviewSI || siAction === 'add'"
                                          [class.p-d-none]="isPreviewSI"
                                          [uploadLabel]="'Upload'"
                                          accept="application/pdf"
                                          (uploadHandler)="emitSiDocumentsForUpload('VGM_DOCUMENT', $event, containerForm?.value, fileUploadVGM)"
                                          chooseIcon="pi pi-upload"
                                          class="fp-file-upload"
                                          mode="basic"
                                          styleClass="p-button-secondary">
                            </p-fileUpload>
                        </div>
                    </div>

                    <div class="p-pt-2 p-text-secondary">
                        {{fileUploadVGM?._files[0]?.name ?
                        'Selected File : ' + fileUploadVGM?._files[0]?.name : (containerForm?.value?.vgmDocument ? 'Uploaded File : ' + containerForm?.value?.vgmDocument?.name : '')}}
                    </div>
                </div>
            </div>
        </div>
        <!--            End: Basic Container Details & Docs-->


        <!--            Start: If Container is Custom Size-->
        <div *ngIf="containerForm?.value.custom && containerForm?.value.cargoType !== 'ODC'"
             class="p-mt-1">
            <div class="p-grid p-ai-center width-100">
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label>Length (Ft)</label>
                        <input class="width-100" formControlName="length"
                               pInputText
                               type="text">
                    </div>
                </div>
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label>Width (Ft)</label>
                        <input class="width-100" formControlName="width"
                               pInputText
                               type="text">
                    </div>
                </div>
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label>Height (Ft)</label>
                        <input class="width-100" formControlName="height"
                               pInputText
                               type="text">
                    </div>
                </div>
            </div>
        </div>
        <!--            End: If Container is Custom Size-->

        <!--            Start: Container Feelings & Weights-->
        <div class="p-mt-1">
            <div class="p-grid p-ai-center width-100">
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label>Commodity *</label>
                        <p-autoComplete (completeMethod)="completeCommodities($event)"
                                        (input)="getCommoditiesByPrefix($event)"
                                        [emptyMessage]="'No Commodities Found'"
                                        [showEmptyMessage]="true"
                                        [suggestions]="filteredCommodities"
                                        appendTo="body"
                                        field="commodityDescription"
                                        formControlName="commodity"
                                        placeholder="Type at-least 3 characters"
                                        styleClass="width-100 si-autocomplete"
                        >
                        </p-autoComplete>
                    </div>
                </div>
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label>Kind of Packages *</label>
                        <p-dropdown [options]="kindOfPackages" appendTo="body"
                                    emptyMessage="No packages found"
                                    filter="true"
                                    filterBy="packageDescription"
                                    formControlName="kindOfPackage"
                                    optionLabel="packageDescription"
                                    optionValue="packageCode"
                                    placeholder="Select..."
                                    styleClass="si-dropdown"></p-dropdown>

                    </div>
                </div>
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label>Number of Packages *</label>
                        <p-inputNumber [max]="10000"
                                       [min]="1"
                                       [showButtons]="!isPreviewSI"
                                       formControlName="numberOfPackage"
                                       styleClass="width-100 si-container-number"></p-inputNumber>
                    </div>
                </div>
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label>{{shipmentType !== 'FCL' ? 'Volume (CBM) *' : 'Volume (CBM)'}}</label>
                        <input class="width-100" formControlName="volume" pInputText
                               type="text"
                        >
                    </div>
                </div>
            </div>
        </div>
        <!--            End: Container Feelings & Weights-->

        <!--            Start: Container Detailed Info-->
        <div class="p-mt-1">
            <div class="p-grid p-ai-center width-100">
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label>Seal Number</label>
                        <input class="width-100" formControlName="sealNumber"
                               pInputText
                               type="text">
                    </div>
                </div>
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-d-flex p-ai-center p-pr-2">
                        <div class="width-100">
                            <div class="p-field">
                                <label>Gross Weight*</label>
                                <input class="width-100" formControlName="grossWeight"
                                       pInputText
                                       type="number">
                            </div>
                        </div>
                        <div>
                            <div class="p-field">
                                <label> &nbsp; </label>
                                <p-dropdown [options]="weightUnit"
                                            appendTo="body"
                                            emptyMessage="No units found"
                                            formControlName="grossWeightUOM"
                                            styleClass="si-dropdown units-dropdown p-ml-2"></p-dropdown>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-d-flex p-ai-center p-pr-2">
                        <div class="width-100">
                            <div class="p-field">
                                <label> Net Weight </label>
                                <input class="width-100" formControlName="netWeight" pInputText
                                       type="text">
                            </div>
                        </div>
                        <div>
                            <div class="p-field">
                                <label> &nbsp; </label>
                                <p-dropdown [options]="weightUnit"
                                            appendTo="body"
                                            emptyMessage="No units found"
                                            formControlName="netWeightUOM"
                                            styleClass="si-dropdown p-ml-2 units-dropdown"></p-dropdown>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-d-flex p-ai-center p-pr-2">
                        <div class="width-100">
                            <div class="p-field">
                                <label> VGM </label>
                                <input class="width-100" formControlName="vgmWeight" pInputText
                                       type="text">
                            </div>
                        </div>
                        <div>
                            <div class="p-field">
                                <label> &nbsp; </label>
                                <p-dropdown [options]="weightUnit"
                                            appendTo="body"
                                            emptyMessage="No units found"
                                            formControlName="vgmWeightUOM"
                                            styleClass="si-dropdown p-ml-2 units-dropdown"></p-dropdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!--            End: Container Detailed Info-->

        <!--            Start: If Container Type is HAZ-->

        <div *ngIf="containerForm.value.cargoType === 'Hazardous'" class="p-mt-1">
            <div class="p-grid width-100 p-ai-center">
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> IMCO Number * </label>
                        <input class="width-100" formControlName="imcoClass" pInputText
                               type="text"
                        >
                    </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> UN Number * </label>
                        <input class="width-100" formControlName="unNumber" pInputText
                               type="text">
                    </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-d-flex p-jc-between p-ai-center">
                        <div>
                            <h5 class="p-m-0" style="opacity: .7;"> MSDS (PDF Only)</h5>
                            <small class="p-text-warning">Max Filesize: 20MB</small>
                        </div>
                        <div>
                            <p-fileUpload #fileUploadMSDS [customUpload]="true"
                                          [class.p-d-none]="isPreviewSI"
                                          [invalidFileSizeMessageDetail]="'File size is greater than 20MB'"
                                          [invalidFileSizeMessageSummary]="'Invalid File Size'"
                                          [maxFileSize]="2e+7"
                                          [disabled]="isPreviewSI || siAction === 'add'"
                                          [uploadLabel]="'Upload'"
                                          accept="application/pdf"
                                          (uploadHandler)="emitSiDocumentsForUpload('MSDS_DOCUMENT', $event, containerForm?.value, fileUploadMSDS)"
                                          chooseIcon="pi pi-upload"
                                          class="fp-file-upload"
                                          mode="basic"
                                          styleClass="p-button-secondary"></p-fileUpload>
                        </div>
                    </div>

                    <div class="p-pt-2 p-text-secondary">
                        {{fileUploadMSDS?._files[0]?.name ?
                        'Selected File : ' + fileUploadMSDS?._files[0]?.name : (containerForm?.value?.msdsDocument ? 'Uploaded File : ' + containerForm?.value?.msdsDocument?.name : '')}}
                    </div>
                </div>
            </div>
        </div>
        <!--            End: If Container Type is HAZ-->

        <!--            Start: If Container Type is REF-->

        <div *ngIf="containerForm.value.cargoType === 'Reefer'" class="p-mt-1">
            <div class="p-grid width-100 p-ai-center">
                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> Set Temperature(°C) * </label>
                        <input class="width-100" formControlName="temperature" pInputText
                               type="text">
                    </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> Humidity(%) * </label>
                        <input class="width-100" formControlName="humidity" pInputText
                               type="text">
                    </div>
                </div>

                <div class="p-col-12 p-md-6 p-lg-3">
                    <div class="p-field">
                        <label> Ventilation(m³/H) * </label>
                        <input class="width-100" formControlName="ventilation" pInputText
                               type="text">
                    </div>
                </div>

            </div>
        </div>
        <!--            End: If Container Type is REF-->

        <!--            End: If Container Type is REF-->
        <div *ngIf="containerForm?.value.cargoType === 'ODC'">
            <div class="p-mt-1">
                <div class="p-grid p-ai-center width-100">
                    <div class="p-col-12 p-md-6 p-lg-3">
                        <div class="p-d-flex p-ai-center p-pr-2">
                            <div class="width-100">
                                <div class="p-field">
                                    <label> Length </label>
                                    <input class="width-100" formControlName="length" pInputText
                                           type="text">
                                </div>
                            </div>
                            <div>
                                <div class="p-field">
                                    <label> &nbsp; </label>
                                    <p-dropdown [options]="measureUnit"
                                                appendTo="body"
                                                emptyMessage="No units found"
                                                formControlName="lengthUOM"
                                                styleClass="si-dropdown units-dropdown p-ml-2"></p-dropdown>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="p-col-12 p-md-6 p-lg-3">
                        <div class="p-d-flex p-ai-center p-pr-2">
                            <div class="width-100">
                                <div class="p-field">
                                    <label> Width </label>
                                    <input class="width-100" formControlName="width"
                                           pInputText
                                           type="text">
                                </div>
                            </div>
                            <div>
                                <div class="p-field">
                                    <label> &nbsp; </label>
                                    <p-dropdown [options]="measureUnit"
                                                appendTo="body"
                                                emptyMessage="No units found"
                                                formControlName="widthUOM"
                                                styleClass="si-dropdown units-dropdown p-ml-2"></p-dropdown>
                                </div>

                            </div>
                        </div>
                    </div>

                    <div class="p-col-12 p-md-6 p-lg-3">
                        <div class="p-d-flex p-ai-center p-pr-2">
                            <div class="width-100">
                                <div class="p-field">
                                    <label> Height </label>
                                    <input class="width-100" formControlName="height" pInputText
                                           type="text">
                                </div>
                            </div>
                            <div>
                                <div class="p-field">
                                    <label> &nbsp; </label>
                                    <p-dropdown
                                            [options]="measureUnit"
                                            appendTo="body"
                                            emptyMessage="No units found"
                                            formControlName="heightUOM"
                                            styleClass="si-dropdown units-dropdown p-ml-2"></p-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="p-col-12 p-md-6 p-lg-3">
                        <div class="p-field">
                            <label> Weight * (Tonnes) </label>
                            <input class="width-100" formControlName="weightInTonnes" pInputText
                                   type="number">
                        </div>
                    </div>
                </div>
            </div>


        </div>

    </div>
</div>
